export const addCompaniesTableColumns = [
  {
    prop: 'fullname',
    title: 'common.fields.full_name',
    width: '30.77%',
    sortingEnabled: true,
  },
  {
    prop: 'ic_number',
    title: 'adm.companies.company_dialog.ico',
    width: '13%',
    sortingEnabled: true,
  },
  {
    prop: 'address_street',
    title: 'common.fields.address',
    width: '26.23%',
    sortingEnabled: true,
  },
  {
    prop: '',
    title: 'adm.companies.company_dialog.add_company',
    width: '30%',
    sortingEnabled: false,
  },
];
